<template>
    <!-- 未发货物资 -->
    <div class="all-height">
        <el-main class="full-screen">
            <el-row :gutter="20" class="full-screen">
                <el-col :span="24" class="all-height">
                    <div class="half-box">
                        <top-table :page="page" @queryByCondition="queryByCondition" @handleCurrentChange = "handleCurrentChange" @handleSizeChange="handleSizeChange" @saveSendDetail="saveSendDetail" :top-loading="topLoading" :is-lock="isLock" :no-send-order-detail-list="noSendOrderDetailList" ref="topTable" @closeSendDetail="closeSendDetail"></top-table>
                    </div>
                    <div class="half-box" style="margin-top: 40px">
                        <bottom-table @printInvoice="printInvoice" :bottom-loading="bottomLoading" :is-lock="isLock" @refreshData="refreshData" :send-detail-list="sendDetailList" ref="bottomTable"></bottom-table>
                    </div>
                </el-col>
            </el-row>
        </el-main>
    </div>
</template>
<script>
    import topTable from './top-table'
    import bottomTable from './bottom-table'
    const printInvoice = 'http://report.craneweihua.com/webroot/decision/view/report?viewlet=wup%252F%25E4%25BE%259B%25E5%25BA%2594%25E5%2595%2586%25E5%258F%2591%25E8%25B4%25A7%25E5%258D%2595.cpt&ref_t=design&ref_c=cbee14d6-559b-4db2-b8e1-37d485aeeef8';
    export default {
        name: 'send-detail',
        components: {
             topTable, bottomTable
        },
        props: ['orderNo', 'toComp', 'sendId', 'isLock'],
        data() {
            return {
                param: {},
                page: {
                    current: 1,
                    size: 10,
                    total: 0
                },
                topLoading: false,
                bottomLoading: false,
                isSubmit: false,
                noSendOrderDetailList: '',
                sendDetailList: '',
            }
        },
        methods: {
            queryByCondition(param) {
                this.page.current = 1;
                this.param = param;
                this.getPreSendOrderDetailList();
            },
            handleCurrentChange(val) {
                this.page.current = val;
                this.getPreSendOrderDetailList();
            },

            handleSizeChange(val) {
                this.page.size = val;
                this.page.current = 1;
                this.getPreSendOrderDetailList();
            },

            closeSendDetail() {
                this.$emit("closeSendDetail", this.isSubmit);
            },

            refreshData() {
                this.getPreSendOrderDetailList();
                this.getSendDetailList();
            },

            printInvoice() {
                if(this.sendId) {
                    this.$store.dispatch('send/send/printSend', this.sendId).then((res) => {
                        if(res.code === '200') {
                            this.isSubmit = true;
                            this.isLock = true;
                            window.open(printInvoice + '&sendId=' + this.sendId);
                        } else {
                            this.isSubmit = false;
                            this.isLock = false;
                            this.$message.error(res.data?res.data : res.message);
                        }
                    });
                }
            },

            saveSendDetail(row) {
                let param = {};
                param.sendId = this.sendId;
                param.orderDetailId = row.orderDetailId;
                param.qty = row.qty;
                this.$store.dispatch('send/send/saveSendDetail', param).then((res)=>{
                    if(res.code === '200'){
                        this.getPreSendOrderDetailList();
                        this.getSendDetailList();
                    }else {
                        this.$message.error(res.data?res.data : res.message);
                    }
                })
            },

            getPreSendOrderDetailList(params) {
                this.topLoading = true;
                this.param.current = this.page.current;
                this.param.size = this.page.size;
                this.param.toComp = this.toComp;
                this.$store.dispatch('send/send/getPreSendOrderDetailList', this.param).then((res) => {
                    this.noSendOrderDetailList = res.records;
                    this.topLoading = false;
                    this.page.total = res.total;
                });
            },

            getSendDetailList() {
                this.bottomLoading = true;
                this.$store.dispatch('send/send/getSendDetailList', this.sendId).then((res) => {
                    this.sendDetailList = res;
                    this.bottomLoading = false;
                });
            }
        },
        created() {
            this.getPreSendOrderDetailList();
            this.getSendDetailList();
        }
    }
</script>
<style scoped>
    .half-box {
        width: 100%;
        height: calc(50% - 20px);
    }
</style>